// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"322":"f0eee332","324":"59b07e7f","465":"2cc21ca5","590":"0f7678a7","692":"6ce6a410","778":"56a1f5fd","820":"a9750cf9","858":"0f127f82","950":"b3f645a6"}[chunkId] + ".chunk.js";
};